import { render, staticRenderFns } from "./dealrecord.vue?vue&type=template&id=828aa1fe&scoped=true&"
import script from "./dealrecord.vue?vue&type=script&lang=js&"
export * from "./dealrecord.vue?vue&type=script&lang=js&"
import style0 from "./dealrecord.vue?vue&type=style&index=0&id=828aa1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828aa1fe",
  null
  
)

export default component.exports